module.exports = __webpack_public_path__ + "static/img/product09.91c09b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product09.png
// module id = NWGK
// module chunks = 1